/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _config = require('../config');

var _captcha = require('../../helper/captcha');

var _browser = require('../../helper/browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Signup = function () {
    function Signup(_ref) {
        var actHashId = _ref.actHashId,
            tracker = _ref.tracker,
            privacyUrl = _ref.privacyUrl;
        (0, _classCallCheck3["default"])(this, Signup);

        _scope.Feature.EventBus(this);

        this.actHashId = actHashId;
        this.tracker = tracker;
        this.smsTimer = null;
        this.privacyUrl = privacyUrl;
        this.config = null;
        this._rop();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Signup, [{
        key: '_rop',
        value: function _rop() {
            rop.On('mudu.questionnaire.live.' + this.actHashId, function (dataStr) {
                var _JSON$parse = JSON.parse(dataStr),
                    type = _JSON$parse.type,
                    data = _JSON$parse.data;

                switch (type) {
                    case 'question.status':
                        // 使用状态更新
                        _scope.MsgBus.Pub('Signup.Status.Change', (0, _stringify2["default"])(data));
                        break;
                    default:
                        break;
                }
            });
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this = this;

            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
                rop.Remove('mudu.questionnaire.live.' + _this.actHashId);
                _scope.MsgBus.UnSubAll('Signup.Status.Change');

                _scope.MsgBus.UnSub(_this.destroyKey);
            });
        }

        /**
         * 停止监听ws消息
         */

    }, {
        key: 'UnSubSignTopics',
        value: function UnSubSignTopics() {
            rop.Remove('mudu.questionnaire.live.' + this.actHashId);
        }

        /**
         * 获取当前正在使用的问卷(包含前置问卷和内置问卷)
         */

    }, {
        key: 'GetUsingSignup',
        value: function GetUsingSignup(cb) {
            var _self = this;
            Fetcher.Get(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/question', function (data) {
                data = JSON.parse(data);
                if (data.errcode === 1000) {
                    data.page_before = _self._formatSignupArr(data.page_before);
                    data.page_in = _self._formatSignupArr(data.page_in);
                    // add pricacy_url to every signup
                    if (data.page_before) {
                        data.page_before = data.page_before.map(function (question) {
                            question.privacy_url = _self.privacyUrl;
                            return question;
                        });
                    }
                    if (data.page_in) {
                        data.page_in = data.page_in.map(function (question) {
                            question.privacy_url = _self.privacyUrl;
                            return question;
                        });
                    }
                }

                typeof cb === 'function' && cb((0, _stringify2["default"])(data));
            }, {
                'Content-Type': 'application/json'
            });
        }

        /**
         * 提交问卷 答案
         * @param {*} param0 { signupId code columns }
         * @param {*} cb 回调函数
         */

    }, {
        key: 'SubmitSingup',
        value: function SubmitSingup(_ref2, cb) {
            var signupId = _ref2.signupId,
                code = _ref2.code,
                columns = _ref2.columns;

            if (typeof signupId !== 'string' && !signupId) {
                // eslint-disable-next-line
                console.warn('SubmitSingup 传入的参数 signupId 不是有效string值');
                return;
            } else if (!columns || Object.prototype.toString.call(columns) !== '[object Array]' || columns.length === 0) {
                // eslint-disable-next-line
                console.warn('SubmitSingup 传入的参数 columns 不是有效值');
                return;
            }
            var _self = this;
            var phone = '';
            var nickname = '';
            columns = columns.map(function (v) {
                if (v.type === 'phone') {
                    phone = v.text;
                } else if (v.type === 'nickname') {
                    nickname = v.text;
                }
                if (v.type === 'question' | v.type === 'questionAnswer') {
                    return {
                        type: v.type,
                        name: v.name,
                        value: (v.selects || []).join(',') + '||' + (v.text || '')
                    };
                } else {
                    return {
                        type: v.type,
                        name: v.name,
                        value: v.text
                    };
                }
            });
            Fetcher.Post(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/' + signupId, (0, _stringify2["default"])({
                columns: columns, verify_code: code || ''
            }), function (data) {
                typeof cb === 'function' && cb(data);
                var tracker = _self.tracker;
                data = JSON.parse(data);
                if (data.errcode === 1000 && tracker && 'function' === typeof tracker.triggerEvent) {
                    tracker.triggerEvent({
                        category: 'interact',
                        action: 'sign_up'
                    });
                    if (phone) {
                        tracker.triggerEvent({
                            category: 'interact',
                            action: 'phone',
                            label: (0, _stringify2["default"])({ phone: phone, is_verified: false })
                        });
                    }
                    if (nickname) {
                        _scope.MsgBus.Pub('User.Update');
                    }
                }
            }, {
                'Content-Type': 'application/json'
            });
        }

        /**
         * 初始化 阿里人机验证
         * @param {*} param0 
         */

    }, {
        key: 'InitCaptcha',
        value: function InitCaptcha(parmas) {
            var isH5 = parmas.isH5,
                width = parmas.width,
                height = parmas.height,
                success = parmas.success,
                fail = parmas.fail,
                renderTo = parmas.renderTo;

            if (typeof isH5 !== 'boolean' && typeof isH5 !== 'undefined') {
                // eslint-disable-next-line
                console.warn('resetCaptcha 传入的参数 isH5 不是boolean值');
                fail && fail();
                return;
            } else if (typeof width !== 'number' || typeof height !== 'number') {
                // eslint-disable-next-line
                console.warn('resetCaptcha 传入的参数 width或height 不是number值');
                fail && fail();
                return;
            } else if (typeof success !== 'function') {
                // eslint-disable-next-line
                console.warn('resetCaptcha 传入的参数 success 不是function');
                fail && fail();
                return;
            } else if (typeof renderTo !== 'string' && /^#/.test(renderTo)) {
                // eslint-disable-next-line
                console.warn('resetCaptcha 传入的参数 renderTo 不正确，应当形如：#yourDomId');
                fail && fail();
                return;
            }

            isH5 = typeof isH5 === 'undefined' ? _browser.isMobile : isH5;

            var _self = this;
            (0, _captcha.initCaptcha)(parmas, function (resetCaptcha) {
                _self.ResetCaptcha = resetCaptcha;
            });
        }

        // 重置阿里人机校验 会被覆盖重写

    }, {
        key: 'ResetCaptcha',
        value: function ResetCaptcha() {
            // eslint-disable-next-line
            console.warn('ResetCaptcha 调用出错，请先调用InitCaptcha');
        }
    }, {
        key: '_formatConfig',
        value: function _formatConfig() {
            this._hasBeenRemovedLog('_formatConfig');
        }
    }, {
        key: '_formatSignupArr',
        value: function _formatSignupArr(signupArr) {
            if (Object.prototype.toString.call(signupArr) === '[object Array]') {
                return signupArr.map(function (v) {
                    v.pic.indexOf('http') != 0 && (v.pic = '//mudu.tv' + v.pic);
                    return v;
                });
            }
            return signupArr;
        }
    }, {
        key: '_startTimer',
        value: function _startTimer() {
            var self = this;
            this.smsTimer = setTimeout(function () {
                self._clearTimer();
            }, 50000);
        }
    }, {
        key: '_clearTimer',
        value: function _clearTimer() {
            clearTimeout(this.smsTimer);
            this.smsTimer = null;
        }
    }, {
        key: 'GetConfig',
        value: function GetConfig() {
            this._hasBeenRemovedLog('GetConfig');
            return this.config;
        }
    }, {
        key: 'SendSmsRequest',
        value: function SendSmsRequest(_ref3, cb) {
            var signupId = _ref3.signupId,
                sig = _ref3.sig,
                sessionId = _ref3.sessionId,
                token = _ref3.token,
                phone_number = _ref3.phone_number,
                isH5 = _ref3.isH5;

            if (typeof signupId !== 'string' && !signupId) {
                // eslint-disable-next-line
                console.warn('SendSmsRequest 传入的参数 signupId 不能为空');
                return;
            } else if (!sig || !sessionId || !token || typeof isH5 !== 'boolean' && typeof isH5 !== 'undefined') {
                // eslint-disable-next-line
                console.warn('SendSmsRequest 传入的参数 sig、sessionId、token、isH5 不能为空或类型不匹配');
                return;
            } else if (!phone_number || typeof phone_number !== 'string') {
                // eslint-disable-next-line
                console.warn('SendSmsRequest 传入的参数 phone_number 不能为空或类型不匹配');
                return;
            } else if (this.timer) {
                typeof cb === 'function' && cb({
                    errcode: 5699,
                    msg: '短信发送频率过高'
                });
            }

            isH5 = typeof isH5 === 'undefined' ? _browser.isMobile : isH5;
            var _self = this;
            Fetcher.Post(_config.API_DOMAIN + '/questionnaire/api/v1/activities/' + this.actHashId + '/source/live/' + signupId + '/auth_code', (0, _stringify2["default"])({
                sig: sig, sessionId: sessionId, token: token, phone_number: phone_number, scene: isH5 ? 'ic_message_h5' : 'ic_message'
            }), function (data) {
                // eslint-disable-next-line
                console.log('----->', data);
                if (data.errcode !== 1000) {
                    _self._clearTimer();
                }
                typeof cb === 'function' && cb(data);
            }, {
                'Content-Type': 'application/json'
            });
        }
    }, {
        key: 'SendSms',
        value: function SendSms() {
            this._hasBeenRemovedLog('SendSms');
        }
    }, {
        key: 'Submit',
        value: function Submit() {
            this._hasBeenRemovedLog('Submit');
        }
    }, {
        key: '_hasBeenRemovedLog',
        value: function _hasBeenRemovedLog(fnName) {
            // eslint-disable-next-line
            console.warn('您当前使用的' + (fnName || '') + '方法已经被移除，详情参见：http://mudu.tv/api/v1/WEB_SDK/COMPONENT/SIGNUP.html');
        }
    }]);
    return Signup;
}();

module.exports = Signup;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Signup.js
 ** module id = 176
 ** module chunks = 1
 **/